// @ts-nocheck
import * as effects from 'redux-saga/effects';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';
import { chatActions } from '../../../chat/actions';

export function* handleMessageIntent(payload) {
  try {
    yield effects.put(wsActions.setSocketsStatus('MESSAGE'));

    yield effects.put(chatActions.setMessageId(payload.id));
    yield effects.put(chatActions.startWaiting());
  } catch (e) {
    yield handleError(e);
  }
}
